const FONT = 'Helvetica';
const rowHeight = 30;
const headerHeight = 0;
const topBarHeight = 0;
const headerInfoHeight = 0 + topBarHeight;
const tableHeaderHeight = 0;
const tableWidth = 750;
const cellWidth = tableWidth / 11 - 28;

export default {
  container: {
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    marginLeft: '5%',
  },

  containerMobile: {
    height: 'calc(94vh - 115px)',
    backgroundColor: 'white',
  },
  mobileContainer: {
    height: 'calc(94vh - 115px)',
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
  },

  SearchBar: {
    margin: '30px 0px 0px 20px',
  },
  Calender: {
    margin: '5px 0px 0px 20px',
  },

  selectors: {
    width: '195px',
    padding: '25px 20px 0px 15px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    justifyContent: 'space-around',
  },
  selectorsMobile: {
    // width: '195px',
    padding: '0px 20px 0px 15px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    justifyContent: 'space-around',
  },
  companyText: {
    fontSize: '0.9rem',
    paddingTop: '10px',
  },
  noTickerText: {
    fontStyle: 'italic',
    fontSize: 14,
  },
  stockPriceInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  stockPrice: {
    fontSize: 16,
  },
  stockPriceMobile: {
    fontSize: 13,
  },
  posPriceChange: {
    color: 'green',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    fontSize: 13,
    marginBottom: 0,
    height: '14px',
  },
  negPriceChange: {
    color: 'red',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    fontSize: 13,
    marginBottom: 0,
    height: '14px',
  },
  downArrow: {
    color: 'red',
    marginBottom: -10,
    marginRight: -5,
    fontSize: 30,
  },
  downArrowMobile: {
    color: 'red',
    marginBottom: -5,
    marginRight: -5,
    marginLeft: -8,
    fontSize: 30,
  },
  upArrow: {
    color: 'green',
    marginBottom: -5,
    marginRight: -5,
    fontSize: 30,
  },
  upArrowMobile: {
    color: 'green',
    marginBottom: -5,
    marginRight: -5,
    marginLeft: -8,
    fontSize: 30,
  },
  priceChange: {
    marginRight: 3,
  },
  refreshButton: {
    marginTop: 5,
  },
  timestampText: {
    fontSize: 10,
    marginTop: '2px',
  },

  TopTable: {
    backgroundColor: 'rgb(216, 228, 244)',
    height: '115px',
    margin: '5px',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    borderCollapse: 'collapse',
    width: '100%',
  },
  tableHead: {
    backgroundColor: '#ddd',
  },
  headingStyle: {
    fontFamily: FONT,
    fontWeight: 'bold',
    marginTop: '2%',
  },
  headingStyleMobile: {
    fontFamily: FONT,
    fontWeight: 'bold',
    marginTop: '2%',
    fontSize: '14px',
  },

  topTableWidth: {
    padding: '0px',
    border: '1.2px solid',
    backgroundColor: '#fffeff',
    width: '60px',
    fontSize: '12px',
    textAlign: 'center',
  },
  //FirstTable
  FirstTabletableCell: {
    color: 'white',
    fontSize: '12',
    lineHeight: '0.0rem',
    textAlign: 'left',
  },
  FirstTablebody: {
    fontSize: '12',
    lineHeight: '0.0rem',
    textAlign: 'left',
  },
  tableRow: {
    height: rowHeight,
  },
  modalTableHeaderCell: {
    background: '#656566',
    color: 'white',
    padding: '0px',
    fontSize: 12,
    width: cellWidth,
    textAlign: 'center',
    top: tableHeaderHeight + headerInfoHeight + headerHeight,
    zIndex: 5,
  },
  modalTableRow: {
    padding: '2px 6px 2px 6px',
    fontSize: 12,
    width: cellWidth,
    borderColor: '#C0C0C0',
    textAlign: 'center',
  },

  TableRowHomePage: {
    height: 15,
    padding: 0,
    fontSize: 12,
    width: cellWidth,
    borderColor: '#C0C0C0',
    textAlign: 'end',
  },

  EarningObject: {
    width: '20px',
    backgroundColor: '#2e76b6',
    color: 'white',
    fontSize: '14px',
    textAlign: 'center',
    margin: 'auto',
    marginLeft: '10px',
  },
  ExDivObject: {
    width: '20px',
    backgroundColor: '#70ad47',
    color: 'white',
    fontSize: '14px',
    textAlign: 'center',
    margin: 'auto',
    marginLeft: '10px',
  },

  boardModalTableContainer: {
    overflowY: 'scroll',
    width: '90%',
    maxHeight: '250px',
    marginTop: '1%',
    marginBottom: '2%',
  },
  boardModalTableContainerMobile: {
    width: '100%',
    overflowY: 'scroll',
    maxHeight: '250px',
    marginTop: '1%',
  },

  dropDown: {
    height: '20px',
    width: '20px',
    marginTop: '5px',
  },
  dropDown2: {
    height: '20px',
    width: '20px',
    marginTop: '7px',
  },
  dropDown3: {
    height: '20px',
    width: '20px',
    marginTop: '8px',
  },
  filterIcon: {
    height: '20px',
    width: '20px',
    marginLeft: '5px',
    paddingTop: '4px',
  },

  //right Side CSS
  articlesFixed: {
    overflowY: 'scroll',
    backgroundColor: 'white',
    marginRight: '30px',
    marginLeft: '30px',
    height: '740px',
    fontSize: '0.85rem',
  },
  articlesTitleFixed: {
    fontSize: '1.17em',
    fontWeight: 'bold',
    marginRight: '30px',
    marginLeft: '30px',
    height: '20px',
    paddingTop: '20px',
    paddingBottom: '10px',
  },
  stockPaper: {
    zIndex: 10,
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '10px',
    height: '100%',
  },
  stockContainer: {
    marginRight: '30px',
    marginLeft: '30px',
    background: 'white',
    width: 'calc(100% - 60px)',
    height: '275px',
  },
  newsContainer: {
    height: '4rem',
    overflow: 'hidden',
    backgroundColor: 'white',
    marginRight: '15px',
    padding: '0.2rem',
  },
  leftNewsPic: {
    width: '35%',
    float: 'left',
    margin: '5px',
  },
  stockDelayText: {
    fontSize: 12,
    color: 'gray',
    fontStyle: 'italic',
  },
  stockDelayTextSmall: {
    fontSize: 10,
    color: 'gray',
    fontStyle: 'italic',
  },
  tickerInput: {
    width: '170px',
    height: 28,
    fontSize: 18,
    fontFamily: FONT,
    color: 'gray',
    // margin: "auto",
    textAlign: 'center',
  },
  tickerInputSmall: {
    width: '107px',
    height: 28,
    fontSize: 18,
    fontFamily: FONT,
    color: 'gray',
    // margin: "auto",
    textAlign: 'center',
  },
  tickerInputMobile: {
    width: '120px',
    height: 22,
    fontSize: 14,
    fontFamily: FONT,
    color: 'gray',
    // margin: "auto",
    textAlign: 'center',
  },
  goButton: {
    marginLeft: 10,
    width: '30px',
    minWidth: 30,
    maxWidth: 30,
    height: '30px',
    background: 'green',
    color: 'white',
    // marginBottom:'6px'
  },
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: 'blue', // Change the color to whatever you want
  },
  
};



// WEBPACK FOOTER //
// ./src/components/CustomDataTable/index.styles.js